import React, { Fragment, FunctionComponent } from "react";

import { Language, useLanguage } from "../../../../i18n/useLanguage";
import {
  PricingContext,
  PromotionLink,
  TirePartItem,
} from "../../../../queries/useSearchTiresByVehicle";

type PromotionLinksProps = {
  part: TirePartItem | null;
  quantity?: string;
};

export const useRebateLinks = (
  language: Language,
  link: [] | PromotionLink = [],
  quantity?: string
): PricingContext[] => {
  const partPricingItem =
    !link || !quantity || Array.isArray(link) ? null : link[quantity];

  const options: PricingContext[] =
    partPricingItem?.contextList.filter(({ linkText }) =>
      Boolean(linkText && linkText[language])
    ) || [];

  return options;
};

export const Rebates: FunctionComponent<PromotionLinksProps> = ({
  part,
  quantity,
}) => {
  const [language] = useLanguage();

  const rebates = useRebateLinks(
    language,
    part?.partPricing.primaryPart.link,
    quantity
  );

  return rebates.length ? (
    <h5 className="bg-input border-b border-edge px-4 md:px-6 xl:px-8 py-1 text-xs flex flex-wrap justify-center items-center">
      {rebates.map(({ linkText, linkURL, promotionText }, key) => {
        const href = linkURL?.[language] || linkURL?.en;
        const linkName = linkText?.[language] || linkText?.en;

        return (
          <Fragment key={key}>
            {key > 0 && <div className="mx-1 lg:mx-2">&middot;</div>}
            {linkText && href ? (
              <a
                className="flex justify-between items-center underline"
                href={href}
                key={key}
                rel="noreferrer"
                target="_blank"
              >
                {linkName}
              </a>
            ) : (
              <span className="flex justify-between items-center" key={key}>
                {promotionText[language] || promotionText.en}
              </span>
            )}
          </Fragment>
        );
      })}
    </h5>
  ) : null;
};
